var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43311 13.0806L1.43311 0.747314",
    stroke: "#007AFC",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0135 7.13413L9.20017 6.3208C9.00684 6.15413 8.89351 5.90747 8.88684 5.63413C8.87351 5.33413 8.99351 5.03413 9.21351 4.81413L10.0135 4.01413C10.7068 3.3208 10.9668 2.65413 10.7468 2.12747C10.5335 1.60747 9.87351 1.3208 8.90018 1.3208L1.43351 1.3208C1.29351 1.32747 1.18018 1.4408 1.18018 1.5808L1.18018 9.5808C1.18018 9.7208 1.29351 9.83413 1.43351 9.83413L8.90018 9.83413C9.86018 9.83413 10.5068 9.5408 10.7268 9.01413C10.9468 8.4808 10.6935 7.8208 10.0135 7.13413Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFill);
export default __webpack_public_path__ + "static/media/flag-fill.1dfb3a1e151446722b78a78884a5c9b9.svg";
export { ForwardRef as ReactComponent };